<template>
  <div class="notice">
    <el-collapse accordion v-model="activeName" @change="handleChange">
      <el-collapse-item name="open" :disabled="list.length == 0">
        <template slot="title">
          <div class="notice-head">
            <div class="notice-title">
              {{ ts('IMPORTANT')['IMPORTANT'] }} <span class="numb">{{ list.length }}</span>
            </div>
            <div class="notice-desc" v-if="list.length > 0">{{ getText(list[0].content) }}</div>
            <div class="notice-desc" v-else>{{ ts('No new announcement')['No new announcement'] }}</div>
          </div>
        </template>
        <div class="notice-content">
          <div class="notice-list" v-if="list.length > 0">
            <div class="item" v-for="item in list" :key="item.id">
              <div class="item-left">
                <div class="avatar">
                  <el-avatar :size="50" :src="item.logo" v-if="item.logo"></el-avatar>
                  <el-avatar :size="50" icon="el-icon-user-solid" v-else></el-avatar>
                </div>
                <div class="name" v-if="item.hotelName">{{ item.hotelName }}</div>
                <div class="time">{{ item.createTime }}</div>
              </div>
              <div class="item-content" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'

export default {
  name: 'Message',
  mixins: [LanguagePackage],
  data() {
    return {
      list: [],
      activeName: '',
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 消息列表
    getList() {
      getAction(`/pc/home/qryPmsProductMsgrecord`, { readingStatus: 0 }).then((res) => {
        this.list = res.result
      })
    },
    readAll() {
      if (this.list.length > 0) {
        const ids = this.list.map((item) => item.id).join(',')
        getAction(`/pc/home/haveRead`, { ids }).then((res) => {})
      }
    },
    handleChange(val) {
      if (val == 'open') {
        this.readAll()
      }
    },
    getText(str) {
      if (str) {
        return str.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi, '')
      }
      return ''
    },
  },
}
</script>

<style scoped lang="scss"></style>
